"use client";

import React, { useEffect, useState, useCallback } from "react";
import Image from "next/image";
import { BATCH_START_FOR_STUDENTS_ROWS_CMA } from "@/lib/utils";

const DESKTOP_IMG =
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit-new/cma_gameplan_pc.webp";
const MOBILE_IMG =
  "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit-new/cma_gameplan_mob.webp";

const CMA_gameplan = () => {
  const [activeTab] = useState("students");
  const [isDesktopScheduleModel, setIsDesktopScheduleModel] = useState(false);
  const [isMobileScheduleModel, setIsMobileScheduleModel] = useState(false);

  const openDesktopScheduleModel = useCallback(() => {
    setIsDesktopScheduleModel(true);
  }, []);

  const closeDesktopScheduleModel = useCallback(() => {
    setIsDesktopScheduleModel(false);
  }, []);

  const openMobileScheduleModel = useCallback(() => {
    setIsMobileScheduleModel(true);
  }, []);

  const closeMobileScheduleModel = useCallback(() => {
    setIsMobileScheduleModel(false);
  }, []);

  useEffect(() => {
    if (isMobileScheduleModel || isDesktopScheduleModel) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMobileScheduleModel, isDesktopScheduleModel]);

  return (
    <>
      <section className="bg-white py-8 px-4 max-md:bg-[#f3f3f3] max-md:p-4">
        <div className="main_container py-5 bg-white rounded-2xl max-md:px-4 max-md:py-6">
          <h2 className="text-center text-[32px] font-bold text-[#1d1d1d] m-0 mb-[30px] leading-[1.3] max-md:text-2xl max-md:mb-6">
            AI-Integrated U.S. <span className="text-[#39f]">CMA Roadmap</span>
          </h2>
          <p className="text-center text-[15px] text-[#888] m-0 mb-10 font-semibold leading-[1.5] max-md:text-[13px] max-md:mb-6">
            Stand out to MNCs within 4 months with CAIRA Level 1 badge on
            LinkedIn
          </p>
          <div className="flex justify-center">
            <Image
              src={DESKTOP_IMG}
              alt="AI-Integrated U.S. CPA Roadmap"
              width={1300}
              height={520}
              className="w-full max-w-[1300px] h-auto object-contain max-md:hidden"
              loading="lazy"
            />
            <Image
              src={MOBILE_IMG}
              alt="AI-Integrated U.S. CPA Roadmap"
              width={600}
              height={900}
              className="hidden w-full h-auto object-contain max-md:block"
              loading="lazy"
            />
          </div>
          <div className="mt-8 flex flex-col items-center gap-3 max-md:mt-6 max-md:gap-2.5">
            <h3 className="text-[24px] font-bold text-[#1d1d1d] text-center leading-[1.3] max-md:text-[18px]">
              Next Batch Starts on{" "}
              <span className="text-[#39f]">25 Oct 2026</span>
            </h3>
            <button
              type="button"
              onClick={openDesktopScheduleModel}
              className="md:mt-4 mt-2 !min-w-[306px] px-[28px] py-[12px] border-0 rounded-tl-[10.85px] rounded-tr-[10.85px] rounded-br-[10.85px] rounded-bl-none bg-[#2a85ff] text-white text-[16px] font-bold leading-none cursor-pointer max-md:hidden"
            >
              View Schedule
            </button>
            <button
              type="button"
              onClick={openMobileScheduleModel}
              className="md:hidden mt-2 !min-w-[306px] px-[28px] py-[12px] border-0 rounded-tl-[10.85px] rounded-tr-[10.85px] rounded-br-[10.85px] rounded-bl-none bg-[#2a85ff] text-white text-[16px] font-bold leading-none cursor-pointer max-md:w-[calc(100%-32px)] max-md:min-w-0 max-md:px-4"
            >
              View Schedule
            </button>
          </div>
        </div>
      </section>

      {isMobileScheduleModel && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div className="rounded-[14px] shadow-lg relative lg:w-[800px] md:w-[800px] h-auto mx-auto w-[800px] bg-white">
            <button
              type="button"
              title="Close schedule"
              aria-label="Close schedule"
              onClick={closeMobileScheduleModel}
              className=" text-[#878787] px-2 text-lg py-2 rounded-full absolute right-[5px] z-[9999]"
            >
              <Image
                quality={50}
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/twitter.webp"
                alt="close"
                width={18}
                height={18}
              />
            </button>
            <div className="bg-black px-[10px] pb-[8px] pt-[8px] rounded-t-[12px]">
              <h3 className="text-[#fff] leading-[1.2] text-center text-[14px] font-bold">
                MILES CMA - PART I
              </h3>
            </div>
            <div className="bg-[#0B3462] px-[15px] pb-[6px] pt-[8px]">
              <h3 className="text-[#ffffff] text-center lg:text-[20px] md:text-[18px] text-[16px] leading-[1.3] font-semibold pb-[8px]">
                Live Online Sessions
              </h3>
            </div>
            <div className=" h-[500px] overflow-y-auto w-full">
              <div className="flex flex-col">
                <table className="border-collapse h-[300px] overflow-y-auto table-auto w-full">
                  <thead>
                    <tr className="text-center bg-[#0B3462] w-full">
                      <th className="px-1 py-2 text-[14px]  font-medium text-[#fff] ">
                        Class
                      </th>
                      <th className="text-[14px] font-semibold text-[#FFF] leading-[1.3]  flex justify-between items-center">
                        <Image
                          quality={50}
                          src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/line.webp"
                          className=""
                          alt="close"
                          width={2}
                          height={18}
                        />
                        <span>
                          Date &<br /> Day
                        </span>
                        <Image
                          quality={50}
                          src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/line.webp"
                          className="mr-[-2px]"
                          alt="close"
                          width={2}
                          height={18}
                        />
                      </th>
                      <th className="text-[14px] font-semibold text-[#FFF] w-[22%] leading-[90%] tracking-[-0.32px]">
                        Time IST <br />
                        <span className="text-[10px] font-normal leading-[125%]">
                          {" "}
                          (GMT+5:30 hours)
                        </span>
                      </th>
                      <th className="text-[14px] font-semibold text-[#FFF] w-[33%] leading-[120%] tracking-[-0.32px] ">
                        <div className="flex justify-start items-center">
                          <Image
                            quality={50}
                            src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/line.webp"
                            className="ml-[-2px]"
                            alt="close"
                            width={2}
                            height={18}
                          />
                          <span className="text-center w-[99%]">
                            Class <br />
                            Schedule
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white ">
                    {BATCH_START_FOR_STUDENTS_ROWS_CMA?.map((item, index) => (
                      <SingleRow key={index} {...item} />
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            {activeTab === "cpa" ? (
              <div className="flex flex-col rounded-[8px] bg-[#3174d626] h-auto w-full py-4 items-center justify-center px-4">
                <p className="text-[#061A2F] text-[12px] font-semibold text-center">
                  One-On-One Mentoring Sessions - Oct - Nov 2025
                </p>

                <p className="text-[#061A2F] text-[12px] font-semibold text-center">
                  Appear for Part 1 Exam in Dec-2025
                </p>

                <p className="text-[#061A2F] text-[12px] font-semibold text-center">
                  * Sunday F2F classes as per city-wise schedules, subject
                  <br /> to minimum registrations
                </p>
              </div>
            ) : (
              <div className="rounded-[8px] bg-[#3174d626] h-auto w-full py-4 items-center justify-center ">
                <p className="text-[#061A2F] text-[12px] font-semibold text-center">
                  One-On-One Mentoring Sessions - Jan  2027- Feb 2027
                  <br />
                  Appear for Part 1 Exam in Mar -2027
                </p>
                <p className="text-[#061A2F] text-[12px] font-semibold text-center">
                  {" "}
                  * Sunday F2F classes as per schedule, subject
                  <br /> to minimum registrations.
                  <br />
                  *Refer LMS for session details
                  <br />* Schedules are subject to change as per management
                  discretion
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      {isDesktopScheduleModel && (
        <div className="fixed rounded-[16px] inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div className="shadow-lg relative lg:w-[800px] md:w-[800px] w-[800px] bg-white rounded-[16px]">
            <div className="bg-black py-2 text-white font-semibold text-[20px] text-center rounded-t-[14px]">
              MILES CMA - PART I{" "}
            </div>
            <div className="bg-[#0B3462] px-[15px] py-[12px] relative">
              <button
                type="button"
                title="Close schedule"
                aria-label="Close schedule"
                onClick={closeDesktopScheduleModel}
                className="mt-1 text-[#878787] px-3 text-lg py-1 rounded absolute right-[10px] top-[0px] z-[9999]"
              >
                <Image
                  src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa/close.svg"
                  alt="close"
                  width={30}
                  height={30}
                />
              </button>
              <h3 className="text-white text-center text-[18px] md:text-[24px] leading-[28px] font-semibold border-b-[0.5px] border-b-[#FFFFFF29] pb-2 uppercase">
                Live Online Sessions
              </h3>
            </div>

            <div className="md:h-[600px] overflow-y-auto rounded-b-[12px] scrollbar-hide">
              <div className="rounded-xl bg-white pb-1">
                <table className="border-collapse table-auto w-full">
                  <thead className=" sticky top-0 z-50 px-[15px] pb-[15px]">
                    <tr className="text-center  bg-[#0B3462]">
                      <th className=" pl-4 py-2 text-[18px] font-sembold text-[#FFF] w-[9%]">
                        Class
                      </th>
                      <th className=" text-[18px] font-sembold text-[#FFF]">
                        Date
                      </th>
                      <th className=" text-[18px] font-sembold text-[#FFF]">
                        Day
                      </th>
                      <th className=" text-[18px] font-sembold text-[#FFF] leading-[1.2]">
                        Time <br />
                        <span className="text-[14px] font-regular text-center">
                          (GMT +5:30 HRS)
                        </span>
                      </th>
                      <th className=" text-[18px] pr-2 font-semibold text-[#FFF]  w-[36%]">
                        Class Schedule
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white ">
                    {BATCH_START_FOR_STUDENTS_ROWS_CMA?.map((item) => (
                      <DesktopSingleRow key={item?.number} {...item} />
                    ))}
                    <tr className="text-center sticky bottom-0 z-50  bg-[#fff] text-[#061A2F]">
                      <td className="px-2 py-3" colSpan={5}>
                        <div className="bg-[#3174d626] text-base font-semibold mx-4 rounded-[8px] tab_sh py-4">
                          One-On-One Mentoring Sessions - Jan  2027- Feb 2027
                          <br></br>Appear for Part 1 Exam in Mar -2027
                          <br />
                          * Sunday F2F classes as per schedule, subject to
                          minimum registrations.
                          <br />
                          *Refer LMS for session details
                          <br />* Schedules are subject to change as per
                          management discretion
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const SingleRow = ({
  number,
  date,
  day,
  time,
  description,
}: {
  number?: string;
  date: string;
  day: string;
  time: string;
  description: string | string[];
}) => {
  return (
    <tr>
      {number ? (
        <td className="text-center text-[12px] font-normal leading-[120%] tracking-[-0.48px] text-[#061A2F] border-b border-l border-[#F5F5F5]/8 px-1 py-4">
          {number}
        </td>
      ) : null}
      <td className="text-center text-[12px] font-medium leading-[120%] tracking-[-0.48px] text-[#061A2F] border-b border-l border-[#F5F5F5]/8">
        {date}
        <span className="text-[#7B8189] text-[10px] font-medium block">
          {day}
        </span>
      </td>
      <td className="text-center text-[12px] font-medium leading-[120%] tracking-[-0.48px] text-[#061A2F] border-b border-l border-[#F5F5F5]/8">
        {time}
      </td>
      <td className="text-center text-[12px] font-medium leading-[120%] tracking-[-0.48px] text-[#061A2F] border-b border-l border-[#F5F5F5]/8">
        {Array.isArray(description)
          ? description?.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < description.length - 1 && <br />}
              </React.Fragment>
            ))
          : description}
      </td>
    </tr>
  );
};

const DesktopSingleRow = ({
  number,
  date,
  day,
  time,
  description,
  isF2F = false,
}: {
  number?: string;
  date: string;
  day: string;
  time: string;
  isF2F?: boolean;
  description: string | string[];
}) => {
  return (
    <tr
      className={`text-center ${isF2F ? "text-[18px]" : "text-[16px]"} border-b border-[#0B346214]/8 text-[#061A2F]`}
    >
      {number ? <td className=" pl-4 py-4">{number}</td> : null}
      <td className={` ${isF2F ? "pl-4 py-4" : ""} md:px-4`}>{date}</td>
      <td className=" md:px-4">{day}</td>
      <td className=" md:px-4">{time}</td>
      <td className={` ${isF2F ? "pr-4 text-left" : "pr-2 text-center"}`}>
        {Array.isArray(description)
          ? description?.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < description.length - 1 && <br />}
              </React.Fragment>
            ))
          : description}
      </td>
    </tr>
  );
};

export default CMA_gameplan;
